const EstatusPedidos = [
  {
    nombre: 'Incompleto',
  },
  {
    nombre: 'Completo',
  },
  {
    nombre: 'En cola',
  },
  {
    nombre: 'Cancelado',
  },
  {
    nombre: 'Revisión Compras',
  },
  {
    nombre: 'Revisión Cobranza',
  },
  {
    nombre: 'Revisión Facturación',
  },
  {
    nombre: 'Rechazado',
  },
];

export {
  EstatusPedidos,
};
